import { render } from "./RecoveryPass.vue?vue&type=template&id=548234b6"
import script from "./RecoveryPass.vue?vue&type=script&lang=js"
export * from "./RecoveryPass.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__